import React, { Component } from "react";
import Table from "../../components/table/Table";
import ActionContainer from "../../components/UIComponent/ActionTableComponent/actionContainer";
import DropdownAction from "../../components/dropdown/DropdownAction";
import FinanceServices from "../../services/axiosServices/apiServices/FinanceServices";
import SwalServices from "../../services/swalServices/SwalServices";
import moment from "moment/moment";
import Checkbox from "../../components/UIComponent/Checkbox";
import { saveAs } from 'file-saver';
import EventRegistrationApprovalDetailsModel from "../../components/entrymanagement/EventRegistrationApprovalDetailsModel";
import { encryptAES } from "../../utils/Encryption";
import { Navigate, Routes } from "react-router-dom";

export default class EventRegistrationApproval extends Component {
  constructor(props) {
    super(props);
    this.financeService = new FinanceServices();
    this.swalServices = new SwalServices();
    this.state = {
      isApproveLoading: false,
      isRejectLoding: false,
      pagination: {
        pageNo: 1,
        pageSize: 10,
        orderByColumn: "",
        orderFlag: 0,
        searchText: "",
        status: 0,
        eventName: "",
      },
      actionDropdownApproved: ["View Details"],
      pendingEventApprovalList: [],
      totalResults: 0,
      selectedIdList: [],
      checkedRow: false,
      checkedHeader: false,
      isRejected: true,
      isApprove: true,
      setRegistrationApprovalModel: false,
      singleEventApprovalDetails: {
        bookingId: 0,
        bookingStatus: "",
        bookingStatusId: 0,
        companyName: "",
        contactPerson: "",
        email: "",
        eventName: "",
        isSelected: false,
        registrationDate: "",
        timeSlotDate: "",
        title: "",
      },
      isLoading: false,
    };
  }

  // updatePaymentHistory = (referenceNo,id) => {
  //   var storedEventDetails = localStorage.getItem("eventDetails");
  //   let reqParam = [id, 0];
  //   if (storedEventDetails !== null) {
  //     storedEventDetails = JSON.parse(storedEventDetails);
  //     if (
  //       storedEventDetails.isMarketTracking === true &&
  //       Number(storedEventDetails.eventVisitorId) > 0
  //     ) {
  //       reqParam = [id, storedEventDetails.eventVisitorId];
  //     } else {
  //       reqParam = [id, 0];
  //     }
  //   } else {
  //     reqParam = [id, 0];
  //   }
  //   //this.setState({ isLoading: true });
  //   this.individualBookingServices.updateFormPaymentHistory(reqParam).then((response) => {
  //     if (response.statusCode === 200 && response.responseItem != null) {
  //       let bookingId =
  //         response.responseItem.responseContent &&
  //           response.responseItem.responseContent.bookingId &&
  //           !isNaN(response.responseItem.responseContent.bookingId)
  //           ? Number(response.responseItem.responseContent.bookingId)
  //           : 0;
  //       if (response.responseItem.responseContent != null && bookingId > 0) {
  //         this.setState({ isLoadingForZeroPrice: false });
  //         let refNo = response.responseItem.responseContent.bookingReferenceNo.replaceAll(' ', '');
  //         let individualId = response.responseItem.responseContent.individualId ? response.responseItem.responseContent.individualId : 0;
  //         let id = encryptAES(individualId)
  //         localStorage.setItem('FillUpForm', id)
  //         Navigate(Routes.OverseasMissionForm, [refNo]);
  //       }
  //     } else {
  //       this.setState({ isLoading: false });
  //       this.swalServices.Error(response.message);
  //     }
  //   });
  // };


  updatePaymentHistory = (referenceNo) => {
    let reqParam = [referenceNo, 0];
    this.financeService.updatePaymentHistory(reqParam).then((response) => {
      if (response.statusCode === 200 && response.responseItem != null) {
        if (response.responseItem.responseContent != null) {
          this.setState({ bookingConfirmationDetails: response.responseItem.responseContent });
        }
      } else {
        this.swalServices.Error(response.message);
      }
    });
  }
  financeGetAllPendingEventApprovalList = () => {
    this.setState({ isLoading: true });
    this.financeService.financeGetAllPendingEventApprovalList(this.state.pagination).then((response) => {
      if (response.statusCode === 200 && response.responseItem.responseContent != null) {
        let data = response.responseItem.responseContent.itemList;
        data.map((x) => {
          x.registrationDate = moment(x.registrationDate).format("DD MMM YYYY");
          x.timeSlotDate = moment(x.timeSlotDate).format("DD MMM YYYY");
          x.isSelected = false;
        });
        this.setState({ pendingEventApprovalList: data, totalResults: response.responseItem.responseContent.totalCount, isApprove: true, isRejected: true })
      } else {
        this.swalServices.Error(response.message);
      }
      this.setState({ isLoading: false });
    })
  }

  financeApproveRejectEventApproval = async (identity) => {
    const isApprove = identity === "Approve";
    const selectedIds = this.state.pendingEventApprovalList.filter(x => x.isSelected).map(x => x.bookingId);
    const isSingleBooking = selectedIds.length === 1;
    let bookingStatusId;
    const loadingKey = isApprove ? "isApproveLoading" : "isRejectLoding";

    // 7 = Pending Payment
    // 9 = Rejected
    // 10 = Processing Approval Emails
    // 11 = Processing Rejected Emails
    if (isApprove) {
      bookingStatusId = isSingleBooking === true ? 7 : 10;
    }
    else {
      bookingStatusId = isSingleBooking === true ? 9 : 11;
    }

    const request = {
      updatedBy: 1,
      updatedAt: moment().format("YYYY-MM-DD"),
      updatedAppId: 114,
      bookingId: selectedIds,
      bookingStatusId
    };

    this.setState({ [loadingKey]: true });

    try {
      const response = isSingleBooking ? await this.financeService.financeApproveRejectEventApproval(request) : await this.financeService.UpdateEventApprovalDetailsforMultipleBookings(request);

      if (response.statusCode !== 200 || !response.responseItem) {
        this.swalServices.Error(response.message);
        return;
      }

      // MULTIPLE BOOKINGS - handle this through scheduler to update payment history for all zero price bookings
      if (!isSingleBooking) {
        this.swalServices.Success(`Your Event Registration is ${isApprove ? "Approved" : "Rejected"}`);
        this.financeGetAllPendingEventApprovalList();
        return;
      }

      // SINGLE BOOKING FLOW
      if (isApprove && isSingleBooking) {
        const items = response.responseItem.responseContent.filter(item => item.bookingReferenceNo && item.totalPrice === 0);

        if (items.length > 0) {
          await new Promise((resolve) => {
            let completed = 0;

            items.forEach(item => {
              this.updatePaymentHistory(item.bookingReferenceNo, () => {
                completed++;
                if (completed === items.length) {
                  resolve();
                }
              });
            });
          });
        }
      }

      this.swalServices.Success(`Your Event Registration is ${isApprove ? "Approved" : "Rejected"}`);
      this.financeGetAllPendingEventApprovalList();
    } catch (error) {
      this.swalServices.Error("Something went wrong.");
    } finally {
      this.setState({ [loadingKey]: false });
    }
  };


  componentDidMount() {
    // this.updatePaymentHistory();
    this.financeGetAllPendingEventApprovalList();
  }

  handleChange = (event) => {
    let { name, value } = event.target;
    let detail = { ...this.state.pagination };
    detail[name] = value;
    detail.pageNo = 1;
    this.setState({ pagination: detail });
  }

  setPagination = (newPagination) => {
    this.setState({ pagination: newPagination }, () => { this.financeGetAllPendingEventApprovalList() });
  };

  actionClick = (index, value, option, event) => {
    if (option === "View Details") {
      let found = this.state.pendingEventApprovalList.find(x => x.bookingId === value);
      if (found) {
        this.setState({ singleEventApprovalDetails: found }, () => {
          event.stopPropagation();
          this.setState({ setRegistrationApprovalModel: true });
        });
      }
    }

  };

  actions = (element, index, value) => {
    return element !== "bookingId" ? null : (
      <td>
        <div className="relative w-full credit-note-action-dropdown">
          <ActionContainer>
            <div className="mr-8">
              <DropdownAction
                key={index}
                value={value}
                id={index}
                index={index}
                options={this.state.actionDropdownApproved}
                align="right"
                onOptionClick={this.actionClick.bind(this)}
              />
            </div>
          </ActionContainer>
        </div>
      </td>
    );
  };

  select = (element, index, value) => {
    return element !== "selectRow" ? null : (
      <td className="px-2 first:pl-5 last:pr-5 whitespace-nowrap tble-td-txt text-[#757575]">
        <input
          name="isRequireQuotation"
          type="checkbox"
          className="cursor-pointer h-6 w-6 rounded check-box-custom"
          onChange={() => this.selectSingleRows(value)}
          checked={this.state.pendingEventApprovalList[index].isSelected === true}
        />
      </td>
    );
  };

  // For Multi Select
  selectSingleRows = (value) => {
    let getAllRows = [...this.state.pendingEventApprovalList];
    let check = getAllRows.find(x => x.bookingId === value)
    let checkedHeader = true;
    if (check.isSelected) {
      getAllRows.map((x) => {
        if (x.bookingId === value) {
          x.isSelected = false;
        }
      })
      this.setState({ isRejected: true, isApprove: true });
    } else {
      getAllRows.map((x) => {
        if (x.bookingId === value) {
          x.isSelected = true;
        }
      })
    }
    let isCheck = false;
    getAllRows.map((x) => {
      if (x.isSelected === true) {
        if (x.bookingStatus !== 'Pending Approval') {
          isCheck = true;
        } else {
          this.setState({ isRejected: false, isApprove: false });
        }
      } else {
        checkedHeader = false;
      }
    })

    if (isCheck) {
      this.setState({ isRejected: isCheck, isApprove: isCheck });
    }
    this.setState({ pendingEventApprovalList: getAllRows, checkedHeader: checkedHeader });
  }


  // For Single Select
  //   selectSingleRows = (value) => {
  //     let getAllRows = [...this.state.pendingEventApprovalList];

  //     // Deselect all rows first
  //     getAllRows = getAllRows.map(x => ({
  //         ...x,
  //         isSelected: x.bookingId === value ? !x.isSelected : false
  //     }));

  //     // Check the new selected row's status
  //     let isCheck = false;
  //     let checkedHeader = true;
  //     let isRejected = true;
  //     let isApprove = true;

  //     getAllRows.forEach(x => {
  //         if (x.isSelected) {
  //             if (x.bookingStatus !== 'Pending Approval') {
  //                 isCheck = true;
  //             } else {
  //                 isRejected = false;
  //                 isApprove = false;
  //             }
  //         } else {
  //             checkedHeader = false;
  //         }
  //     });

  //     if (isCheck) {
  //         isRejected = true;
  //         isApprove = true;
  //     }

  //     this.setState({
  //         pendingEventApprovalList: getAllRows,
  //         checkedHeader: checkedHeader,
  //         isRejected: isRejected,
  //         isApprove: isApprove
  //     });
  // };


  selectAllRows = () => {
    let getAllRows = [...this.state.pendingEventApprovalList];
    let isAnyApproveReject = 0;
    if (this.state.checkedHeader) {
      getAllRows.map((item) => {
        item.isSelected = false;
      });
      this.setState({ pendingEventApprovalList: getAllRows, checkedHeader: false, isRejected: true, isApprove: true });
    } else {
      getAllRows.map((item) => {
        item.isSelected = true;
        if (item.bookingStatus !== 'Pending Approval') {
          isAnyApproveReject += 1;
        }
      });

      getAllRows.map((item) => {
        item.isSelected = true;

      });
      if (isAnyApproveReject > 0) {
        this.setState({ isRejected: true, isApprove: true });
      } else {
        this.setState({ isRejected: false, isApprove: false });
      }
      this.setState({ pendingEventApprovalList: getAllRows, checkedHeader: true });
    }
  }

  render() {
    return (
      <div className="main-body-section finance-body-sec">
        <div className="bg-white pb-2 mt-10">
          <div className="grid grid-cols-12 gap-6 w-full items-center px-8 pt-10 pb-12">
            <div className=" 2xl:col-span-4 lg:col-span-4 col-span-12 w-full">
              <h2 className="text-xl theme-color mb-1">Event Name / Contact Person</h2>
              <input
                id="default"
                name="eventName"
                className="form-input rounded-none w-full shadow-red py-3 text-lg"
                type="text"
                value={this.state.pagination.eventName}
                onChange={(e) => this.handleChange(e)}
              />
            </div>
            <div className="2xl:col-span-2 lg:col-span-2 col-span-12 w-full">
              <div className="mt-8 flex items-center justify-end w-full">
                <button className="btn btn-red text-xl border text-white "
                  onClick={() => { this.financeGetAllPendingEventApprovalList() }}
                >
                  Search
                </button>
              </div>
            </div>
          </div>
        </div>
        {/* Table Section Start */}
        <div className="mt-10 event-registration-approval">
          <Table
            columns={[
              { name: "selectRow", title: <Checkbox handleCheckbox={() => this.selectAllRows()} checkedHeader={this.state.checkedHeader} /> },
              { name: "registrationDate", title: "Registration Date" },
              { name: "eventName", title: "Event Name" },
              { name: "timeSlotDate", title: "Event Date" },
              { name: "contactPerson", title: "Contact Person" },
              // { name: "email", title: "Email" },
              // { name: "companyName", title: "Company Name" },
              // { name: "title", title: "Job Title" },
              { name: "bookingStatus", title: "Status" },
              { name: "bookingId", title: "Actions" },
            ]}
            rows={this.state.pendingEventApprovalList}
            isLoading={this.state.isLoading}
            sortingColumns={["registrationDate", "timeSlotDate", "eventName"]}
            pagination={this.state.pagination}
            totalResultes={this.state.totalResults}
            totalCount={this.state.totalResults}
            setPagination={this.setPagination.bind(this)}
            customScope={[
              {
                column: "bookingId",
                renderTableData: this.actions.bind(this),
              },
              {
                column: "selectRow",
                renderTableData: this.select.bind(this),
                valueColumnName: "bookingId",
              },
            ]}
            isRequiredButton1={true}
            buttonText1="Reject"
            button1Click={() => { this.financeApproveRejectEventApproval("Reject") }}
            button1Disable={this.state.isRejected}
            isRequiredButton2={true}
            buttonText2="Approve"
            button2Click={() => { this.financeApproveRejectEventApproval("Approve") }}
            button2Disable={this.state.isApprove}
            isApproveLoading={this.state.isApproveLoading}
            isRejectLoding={this.state.isRejectLoding}
          />
        </div>
        {/*Table Section End */}


        <EventRegistrationApprovalDetailsModel

          setRegistrationApprovalModel={
            this.state.setRegistrationApprovalModel
          }
          setOpenModal={() =>
            this.setState({ setRegistrationApprovalModel: false })
          }
          onClose={(e) => {
            e.stopPropagation();
            this.setState({ setRegistrationApprovalModel: false });
          }}
          singleEventApprovalDetails={this.state.singleEventApprovalDetails}

        />

      </div>
    );
  }
}  